<template>
  <div>
    <AuthTest />
    <Login />
    <Register />
    <Logout />
  </div>
</template>

<script>
import Login from "./Login";
import Register from "./Register";
import Logout from "./Logout";
import AuthTest from "./AuthTest";

export default {
  name: "Auth",
  components: { AuthTest, Logout, Register, Login }
};
</script>

<style scoped></style>
